import { useEffect, useState, type ReactElement } from 'react';
import { initZoomApp, type AppContext } from './lib/zoom-sdk.ts';
import { HostPanel } from './host/HostPanel.tsx';
import { ParticipantPanel } from './participant/ParticipantPanel.tsx';

type State =
  | { kind: 'loading' }
  | { kind: 'error'; message: string }
  | { kind: 'ready'; ctx: AppContext };

export function App(): ReactElement {
  const [state, setState] = useState<State>({ kind: 'loading' });

  useEffect(() => {
    let cancelled = false;
    initZoomApp()
      .then((ctx) => {
        if (!cancelled) setState({ kind: 'ready', ctx });
      })
      .catch((e: unknown) => {
        if (!cancelled) {
          setState({
            kind: 'error',
            message: e instanceof Error ? e.message : String(e),
          });
        }
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (state.kind === 'loading') {
    return <div data-testid="loading">Loading…</div>;
  }
  if (state.kind === 'error') {
    return (
      <div data-testid="error" role="alert">
        Failed to initialize: {state.message}
      </div>
    );
  }
  return state.ctx.role === 'host' || state.ctx.role === 'coHost' ? (
    <HostPanel ctx={state.ctx} />
  ) : (
    <ParticipantPanel ctx={state.ctx} />
  );
}
